module.exports = __webpack_public_path__ + "img/group1858.9a805cf0.svg";